
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiEsperienzeGrid extends Serenity.EntityGrid<ProdottiEsperienzeRow, any> {
        protected getColumnsKey() { return ProdottiEsperienzeColumns.columnsKey; }
        protected getDialogType() { return ProdottiEsperienzeDialog; }
        protected getIdProperty() { return ProdottiEsperienzeRow.idProperty; }
        protected getInsertPermission() { return ProdottiEsperienzeRow.insertPermission; }
        protected getLocalTextPrefix() { return ProdottiEsperienzeRow.localTextPrefix; }
        protected getService() { return ProdottiEsperienzeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}